import type { IconProps } from "@mui/material";
import type {
    FilterDateEqualsEnum,
    FilterNumberEqualsEnum,
    FilterTextEqualsEnum,
} from "api/common/filters";
import type { TIconName } from "components/Icon";
import type { ReactNode } from "react";

export interface IPaginationData {
    pageNumber: number;
    pageSize: number;
    totalItemCount?: number;
}

export interface ISortData {
    sort: string;
    direction: SortOrderEnum;
}

export enum SortOrderEnum {
    Asc,
    Desc,
}

export interface IFilterTextValue {
    name: string;
    value: string;
    searchType: FilterTextEqualsEnum;
}
export interface IFilterNumberValue {
    name: string;
    value?: number | "";
    searchType: FilterNumberEqualsEnum;
}
export interface IFilterListValue {
    name: string;
    value?: string[] | number[];
    searchType: FilterNumberEqualsEnum;
}
export interface IFilterDateValue {
    name: string;
    value?: Date;
    searchType: FilterDateEqualsEnum;
}
export interface IFilterBooleanValue {
    name: string;
    value?: boolean;
    searchType: FilterNumberEqualsEnum;
}

export type TFilterValue =
    | IFilterTextValue
    | IFilterNumberValue
    | IFilterDateValue
    | IFilterBooleanValue
    | IFilterListValue;

export interface IGoodTableCellBooleanConfig {
    true?: IGoodTableCellBooleanConfigValue;
    false?: IGoodTableCellBooleanConfigValue;
}
export interface IGoodTableCellBooleanConfigValue {
    title: string;
    cell?: ReactNode;
    icon?: {
        name: TIconName;
        color: IconProps["color"];
    };
}
